module.exports = __webpack_public_path__ + "static/media/que_ans.8faa25e3.png";